module.exports = __webpack_public_path__ + "static/media/MEINP_MENU-normal.7d247bd9.png";